import { RichContent } from 'ricos-schema';
import { createParagraphNode, createTextNode, initializeMetadata } from '../../nodeUtils.js';
import '../../../ReadonlyNonEmptyArray-3599e877.js';
import '../../../string-04247af1.js';
import 'lodash';
import 'uuid';
import '../../../utils.js';
import '../../generateRandomId.js';

const fromPlainText = (text) => {
  const paragraphs = text.split("\n").map(
    (paragraph) => createParagraphNode(paragraph ? [createTextNode(paragraph)] : [])
  );
  const content = {
    nodes: paragraphs,
    metadata: initializeMetadata()
  };
  return RichContent.fromJSON(content);
};

export { fromPlainText };
//# sourceMappingURL=fromPlainText.js.map
